/* eslint-disable no-unused-vars */
import {
    Text6,
    Text3,
    IconMobileDeviceRegular,
    Text2,
    Spinner,
    IconHotlineRegular,
    IconTelephonePotRegular,
    EmptyState,
    RowList,
    Row,
    skinVars,
    IconCallLandlineRegular,
} from '@telefonica/mistica';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { dateToLongMonth, getFormatDate } from '../../../utils/dataTransformation/dateConversions';
import './index.scss';
import { formatMobileNumber, formatPrices, formatTimeDetail } from '../../../utils/dataTransformation/unitsConversion';
import { useSearchParams } from 'react-router-dom';
import { getAllConsDetail } from '../../../services/ConsumptionService';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ErrorStateUIData } from '../../../models/interfaces';
import { setInfoError } from '../../../utils/dataTransformation/errorMesssages';
import { AxiosError } from 'axios';

const DetailConsumptionVoice: React.FC = () => {
    const [isLoading, setLoading] = useState(true);
    const [listVoice, setListVoice] = useState([]);
    const [searchParams] = useSearchParams();
    const productPsId: any = searchParams.get('productPsId');
    const [page, setPage] = useState(1);
    const [moreElements, setMoreElements] = useState(true);
    const [error, setError] = useState<ErrorStateUIData>({ title: '', localizedDescription: '', id: '' });
    const [hasError, setHasError] = useState(false);

    const itemIcon = (number: any) => {
        let aux1 = number?.charAt(0);
        let arrExtraSpent = ['901', '902', '803', '806', '807', '905', '118'];
        if (aux1 === '6' || aux1 === '7') {
            return <IconMobileDeviceRegular color={skinVars.colors.neutralHigh} size={24} />;
        } else {
            let aux3 = number?.substring(0, 3);
            let found = arrExtraSpent.find((e) => e === aux3);
            if (found) {
                return <IconHotlineRegular color={skinVars.colors.neutralHigh} size={24} />;
            } else {
                return <IconTelephonePotRegular color={skinVars.colors.neutralHigh} size={24} />;
            }
        }
    };

    useEffect(() => {
        setPage(1);
        setListVoice([]);
        setMoreElements(false);
        getMoreDetails();
    }, []);

    const getMoreDetails = () => {
        const params = {
            productPsId: productPsId,
            consumptionType: 'VOICE',
            page: page,
            size: 25,
        };
        setLoading(true);
        getAllConsDetail(params)
            .then((res: any) => {
                const data = res.data.details;
                setListVoice(listVoice.concat(data));
                setPage(page + 1);
                setMoreElements(res.data.moreElements);
                setLoading(false);
            })
            .catch((err: AxiosError) => {
                setError(setInfoError(err));
                setHasError(true);
                setLoading(false);
            });
    };

    if (isLoading) {
        return (
            <div className='extraExpenseDetails-page'>
                <div className='extraExpenseDetails-page__loading'>
                    <div className='extraExpenseDetails-page__loading__spinner'>
                        <Spinner size={24} color={skinVars.colors.navigationBarBackground}></Spinner>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='DetailConsumptionVoice'>
            {!isLoading && !hasError && listVoice.length > 0 ? (
                <InfiniteScroll
                    dataLength={listVoice.length}
                    next={getMoreDetails}
                    hasMore={moreElements}
                    loader={<h4>Loading...</h4>}
                >
                    <RowList>
                        {listVoice.map((item: any, index: number) => {
                            let pivot = ' ';
                            const longMonth = dateToLongMonth(item.dateTime.substring(5, 7));
                            if (index != 0) {
                                const value: any = listVoice[index - 1];
                                pivot = value.dateTime.substring(8, 10);
                            }
                            if (index == 0) {
                                return (
                                    <div key={index}>
                                        <div className='DetailConsumptionVoice__item-text'>
                                            <Text3 medium color={skinVars.colors.textSecondary}>
                                                {getFormatDate(item?.dateTime, '00 MMMM')}
                                            </Text3>
                                        </div>

                                        <Row
                                            title=''
                                            key={index}
                                            asset={itemIcon(item?.number)}
                                            right={
                                                <div>
                                                    <Text6
                                                        color={
                                                            item?.cost > 0
                                                                ? skinVars.colors.errorHigh
                                                                : skinVars.colors.textPrimary
                                                        }
                                                    >
                                                        {formatPrices(item?.cost, 'spent')}
                                                    </Text6>
                                                </div>
                                            }
                                            headline={
                                                <div className='DetailConsumptionVoice__row-headline'>
                                                    <div className='DetailConsumptionVoice__row-headline-consumption'>
                                                        <div>
                                                            <Text3 regular>{formatMobileNumber(item.number)}</Text3>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            extra={
                                                <div className='DetailConsumptionVoice__row-extra'>
                                                    <Text2 regular color={skinVars.colors.textSecondary}>
                                                        {`${getFormatDate(item.dateTime, '00:00')} - ${formatTimeDetail(
                                                            item.usage,
                                                        )}`}
                                                    </Text2>
                                                </div>
                                            }
                                        ></Row>
                                    </div>
                                );
                            } else if (pivot != item.dateTime.substring(8, 10)) {
                                return (
                                    <div key={index}>
                                        <div className='DetailConsumptionVoice__item-text'>
                                            <Text3 medium color={skinVars.colors.textSecondary}>
                                                {item.dateTime.substring(8, 10)} {longMonth}
                                            </Text3>
                                        </div>

                                        <Row
                                            title=''
                                            key={index}
                                            asset={itemIcon(item.number)}
                                            right={
                                                <div>
                                                    <Text6
                                                        color={
                                                            item.cost > 0
                                                                ? skinVars.colors.errorHigh
                                                                : skinVars.colors.textPrimary
                                                        }
                                                    >
                                                        {formatPrices(item.cost, 'spent')}
                                                    </Text6>
                                                </div>
                                            }
                                            headline={
                                                <div className='DetailConsumptionVoice__row-headline'>
                                                    <div className='DetailConsumptionVoice__row-headline-consumption'>
                                                        <div>
                                                            <Text3 regular>{formatMobileNumber(item.number)}</Text3>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            extra={
                                                <div className='DetailConsumptionVoice__row-extra'>
                                                    {/* <Text2 regular color={skinVars.colors.textSecondary}>
                                                    {item.number}
                                                </Text2> */}
                                                    <Text2 regular color={skinVars.colors.textSecondary}>
                                                        {`${getFormatDate(item.dateTime, '00:00')} - ${formatTimeDetail(
                                                            item.usage,
                                                        )}`}
                                                    </Text2>
                                                </div>
                                            }
                                        ></Row>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={index}>
                                        <Row
                                            title=''
                                            key={index}
                                            asset={itemIcon(item.number)}
                                            right={
                                                <div>
                                                    <Text6
                                                        color={
                                                            item.cost > 0
                                                                ? skinVars.colors.errorHigh
                                                                : skinVars.colors.textPrimary
                                                        }
                                                    >
                                                        {formatPrices(item.cost, 'spent')}
                                                    </Text6>
                                                </div>
                                            }
                                            headline={
                                                <div className='DetailConsumptionVoice__row-headline'>
                                                    <div className='DetailConsumptionVoice__row-headline-consumption'>
                                                        <div>
                                                            <Text3 regular>{formatMobileNumber(item.number)}</Text3>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            extra={
                                                <div className='DetailConsumptionVoice__row-extra'>
                                                    {/* <Text2 regular color={skinVars.colors.textSecondary}>
                                                    {item.number}
                                                </Text2> */}
                                                    <Text2 regular color={skinVars.colors.textSecondary}>
                                                        {`${getFormatDate(item.dateTime, '00:00')} - ${formatTimeDetail(
                                                            item.usage,
                                                        )}`}
                                                    </Text2>
                                                </div>
                                            }
                                        ></Row>
                                    </div>
                                );
                            }
                        })}
                    </RowList>
                </InfiniteScroll>
            ) : (
                !hasError && (
                    <div className='DetailConsumptionVoice__emptyState'>
                        <EmptyState
                            icon={<IconCallLandlineRegular color={skinVars.colors.brand} size={64} />}
                            title={t('titleCallsDetails')}
                            description={t('descriptionCallsDetails')}
                        ></EmptyState>
                    </div>
                )
            )}
        </div>
    );
};

export default DetailConsumptionVoice;
